import { useEffect, useState } from "react"
import SolicitacaoService from "../../../../services/SolicitacaoService"
import { Autocomplete } from "@material-ui/lab"
import { CircularProgress, TextField } from "@material-ui/core"
import { cpfCnpj } from "../../../../functions";

export default function PesquisaOrgaoJuriscionado({
    value,
    setValue,
    error,
    disabled,
    titulo,
    pesquisaParaDeferirAcessoGestor }) {

    const [open, setOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [pesquisaOrgaoJuriscionado, setPesquisaOrgaoJuriscionado] = useState(false)

    const loading = open && pesquisaOrgaoJuriscionado

    const PesquisaOrgao = async (cnpjNomeOrgao) => {
        let cnpjNome = cnpjNomeOrgao.replace("/", "")
        setPesquisaOrgaoJuriscionado(true);
        SolicitacaoService.ConsultaOrgaoPorCnpjOuNome(cnpjNome, false)
            .then(response => {
                let _listaOrgaos = response.data

                if (pesquisaParaDeferirAcessoGestor === true) {
                    const idOrgaoTCE = 119
                    // Remove o órgão TCE, pois não pode deferir acesso de gestor para o órgão TCE.
                    let indiceOrgaoTCE = _listaOrgaos.findIndex(orgao => orgao.id === idOrgaoTCE);
                    if (indiceOrgaoTCE > -1) {
                        _listaOrgaos.splice(indiceOrgaoTCE, 1);
                    }
                }

                setOptions(_listaOrgaos)
                setPesquisaOrgaoJuriscionado(false);
            })
            .catch(() => {
                setOptions([])
                setPesquisaOrgaoJuriscionado(false);
            })
    }

    useEffect(() => {
        if (!loading) {
            return undefined
        }
    }, [loading])

    useEffect(() => {
        if (!open) {
            setOptions([])
        }
    }, [open])

    return (
        <Autocomplete
            multiple={false}
            open={open}
            onOpen={() => {
                setOpen(true)
            }}
            onClose={() => {
                setOpen(false)
            }}
            value={value}
            onChange={(event, newValue) => {
                setOptions([]);
                setValue(newValue);
            }}
            getOptionLabel={(option) => `${option.nome === null || option.nome === undefined ? "" : option.nome}${option.cnpj === null || option.cnpj === undefined ? "" : ` - ${cpfCnpj(option.cnpj)}`}`}
            options={options}
            loading={loading}
            loadingText="Carregando dados..."
            noOptionsText="Nenhum resultado encontrado"
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={titulo}
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress style={{ color: 'var(--primary)' }} size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                    onChange={event => PesquisaOrgao(event.target.value)}
                    error={error ? error.errorState : false}
                    helperText={error ? error.errorHelperText : ""}
                    placeholder="Digite o CNPJ ou o nome do órgão jurisdicionado"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled={disabled}
                />

            )}
            clearText={'Limpar'}
            disabled={disabled}
        />
    )
}